/**
 * 将扁平商品列表组装为 SPU → SKC → SKU 三级树（用于 SHEIN 商品管理表格）。
 */
export function buildSheinProductTree(items) {
  const list = Array.isArray(items) ? items : [];
  const spuMap = new Map();

  for (const item of list) {
    const spuKey = item.platformSpuId || `spu-${item.id}`;
    if (!spuMap.has(spuKey)) {
      spuMap.set(spuKey, {
        key: spuKey,
        spuId: item.platformSpuId || '—',
        title: item.title || '—',
        image: item.primaryImageUrl,
        supplierCode: item.supplierCode || item.supplierItemNo || '',
        skcs: new Map(),
      });
    }
    const spuNode = spuMap.get(spuKey);
    if (!spuNode.supplierCode && item.platformSkuId) {
      spuNode.supplierCode = item.platformSkuId;
    }
    if ((!spuNode.title || spuNode.title === '—') && item.title) {
      spuNode.title = item.title;
    }
    if (!spuNode.image && item.primaryImageUrl) {
      spuNode.image = item.primaryImageUrl;
    }

    const skcKey = item.platformSkcId || `skc-${item.id}`;
    if (!spuNode.skcs.has(skcKey)) {
      spuNode.skcs.set(skcKey, {
        key: skcKey,
        skcId: item.platformSkcId || '—',
        image: item.primaryImageUrl,
        specLabel: item.skcSpecLabel || item.colorName || '',
        skus: [],
      });
    }
    const skcNode = spuNode.skcs.get(skcKey);
    if (!skcNode.image && item.primaryImageUrl) {
      skcNode.image = item.primaryImageUrl;
    }
    skcNode.skus.push(item);
  }

  return Array.from(spuMap.values()).map((spu) => ({
    ...spu,
    skcs: Array.from(spu.skcs.values()),
  }));
}

export function countSheinTreeRows(spuTree) {
  return spuTree.reduce(
    (sum, spu) => sum + Math.max(1, spu.skcs.length),
    0,
  );
}

export function collectSheinTreeProductIds(spuTree) {
  const ids = [];
  for (const spu of spuTree) {
    for (const skc of spu.skcs) {
      for (const sku of skc.skus) {
        if (sku?.id != null) ids.push(String(sku.id));
      }
    }
  }
  return ids;
}

/** 选择/删除用的 SPU 键（优先平台 SPU，否则树节点 key） */
export function spuSelectionKey(spu) {
  const id = String(spu?.spuId || '').trim();
  if (id && id !== '—') return id;
  return String(spu?.key || '').trim();
}

export function collectSheinTreeSpuKeys(spuTree) {
  const keys = [];
  for (const spu of spuTree || []) {
    const key = spuSelectionKey(spu);
    if (key) keys.push(key);
  }
  return keys;
}

export function collectSpuProductIds(spu) {
  const ids = [];
  for (const skc of spu.skcs) {
    for (const sku of skc.skus) {
      if (sku?.id != null) ids.push(String(sku.id));
    }
  }
  return ids;
}

export function sumSkcSales7d(skus) {
  let total = 0;
  let hasValue = false;
  for (const sku of skus) {
    const n = Number(sku?.salesLast7Days);
    if (!Number.isNaN(n)) {
      total += n;
      hasValue = true;
    }
  }
  return hasValue ? total : null;
}

export function sumSkcStock(skus, field = 'stockAvailableQty') {
  let total = 0;
  let hasValue = false;
  for (const sku of skus || []) {
    const raw = field === 'stockAvailableQty'
      ? (sku?.stockAvailableQty ?? sku?.stockQty)
      : sku?.[field];
    const n = Number(raw);
    if (!Number.isNaN(n)) {
      total += n;
      hasValue = true;
    }
  }
  return hasValue ? total : null;
}

export function pickSkcRepresentative(skus) {
  if (!skus?.length) return null;
  return skus[0];
}
